<script lang="ts">
    import Fa from 'svelte-fa'
    import type { ZChatMessageEntity } from './zchat'
    import { faList } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    import markdownit from 'markdown-it'
    const md = markdownit({
        breaks: true,
    })

    export let message: ZChatMessageEntity

    let text = message.text
    let label = message.label
    if (message.type === 'text') {
        text = md.render(message.text)
    } else if (message.label) {
        label = md.render(message.label)
    }

    function open() {
        dispatch('open', message)
    }
</script>

<div class="chat-message chat-message-type-{message.type}" class:chat-message-me={message.isMe}>
    {#if message.type === 'playlist'}
        <div class="-video" on:click={open}>
            <img src={message.text} />
            <Fa icon={faList}></Fa>
        </div>
    {/if}
    <div class="-content">
        {#if message.type === 'text'}
            <div class="-text">{@html text || ''}</div>
        {:else if message.label}
            <div class="-text">{@html label || ''}</div>
        {/if}
        {#if message.time}
            <div class="-time">{window.api.utils.utils.dateFriendly(message.time)}</div>
        {/if}
    </div>
</div>
